module.exports = __webpack_public_path__ + "static/estimated-worldwide-amazon-gmv-ecde54e4ab3795e61dbe46d5c78f87a3.png";